import { render, staticRenderFns } from "./AddPickupGroups.vue?vue&type=template&id=edde91c0&"
import script from "./AddPickupGroups.vue?vue&type=script&lang=js&"
export * from "./AddPickupGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports